export default __webpack_public_path__ + "static/sustainability-construction-cc2acef967e8ee5bfe404e53ef66db93.jpg";